const CUSTOMER_MEMO_DRAFT_PREFIXES = [
  'sgez:customer-memo-draft:',
  'sgez:customer-memo-edit-draft:',
  'sgez:customer-memo-popup-draft:',
  'sgez:app-customer-memo-editor:',
]

function firstIdentityValue(user, keys) {
  for (const key of keys) {
    const value = user?.[key]
    if (value != null && String(value).trim()) return String(value).trim()
  }
  return ''
}

function encodeKeyPart(value) {
  return encodeURIComponent(String(value || '').trim())
}

export function customerMemoDraftScope(user) {
  const userId = firstIdentityValue(user, ['id', 'userId', 'email', 'username'])
  if (!userId) return ''
  const orgId = firstIdentityValue(user, ['orgId', 'organizationId']) || 'personal'
  return `u:${encodeKeyPart(userId)}:o:${encodeKeyPart(orgId)}`
}

export function customerMemoDraftKey({ user, surface, customerId, memoId = 'new' } = {}) {
  const scope = customerMemoDraftScope(user)
  const normalizedCustomerId = String(customerId ?? '').trim()
  const normalizedSurface = String(surface || 'editor').trim()
  const normalizedMemoId = String(memoId ?? 'new').trim() || 'new'
  if (!scope || !normalizedCustomerId || !normalizedSurface) return ''
  return [
    'sgez:customer-memo-draft:v2',
    scope,
    `s:${encodeKeyPart(normalizedSurface)}`,
    `c:${encodeKeyPart(normalizedCustomerId)}`,
    `m:${encodeKeyPart(normalizedMemoId)}`,
  ].join(':')
}

export function clearCustomerMemoDraftStorage(storage) {
  const target = storage || (typeof window !== 'undefined' ? window.sessionStorage : null)
  if (!target) return 0
  let removed = 0
  try {
    const keys = Array.from({ length: target.length }, (_, index) => target.key(index)).filter(Boolean)
    keys.forEach((key) => {
      if (!CUSTOMER_MEMO_DRAFT_PREFIXES.some((prefix) => key.startsWith(prefix))) return
      target.removeItem(key)
      removed += 1
    })
  } catch {
    return removed
  }
  return removed
}
